import { analyticsPageLoad } from "../state/modules/analytics/actions";
import get from "lodash/get";
import unset from "lodash/unset";
import commonConfig from "../config/common";

const {
  globalKeys: { pageLoadDataKey, eventBusKey }
} = commonConfig;

const setup = ({ dispatch }) => {
  const eventBus = get(window, eventBusKey);
  eventBus.addListener("analytics-ready", () => {
    const pageLoadData = get(window, pageLoadDataKey);
    unset(window, pageLoadDataKey);
    dispatch(analyticsPageLoad(pageLoadData));
  });
};

export default setup;
